@if (this.payment$ | async; as accountMoves) {
  <div
    class="tab-pane fade flex-even active show"
    id="contacts"
    role="tabpanel"
    aria-labelledby="contacts-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <div class="ps-3">
            <button
              type="button"
              [class]="ButtonType.Primary | buttontypepipe"
              class="btn-sm btn"
              translate
            (click)="
              openModalCreatePayment(this.contactId)
            "
              >
              CONTACT_LBL_PAYMENT_ADD
            </button>
            <button
              type="button"
              [class]="ButtonType.Primary | buttontypepipe"
              class="btn-sm btn"
              translate
              (click)="openModalSlipContent(this.contactId)"
              >
              CONTACT_LBL_IMPORT_SLIP
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <table class="table table-striped border-bottom">
          <thead>
            <tr>
              <th>
                <a translate>PAYMENT_LBL_DATE</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_MODE</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_AMOUNT</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_PROOF</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_STATUS</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_ACTIONS</a>
              </th>
              <th>
                <a translate>PAYMENT_LBL_ACCOUNT_MOVE_SLIP_BINDED</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (accountMove of accountMoves; track trackByAccountMoveId($index, accountMove)) {
              <ng-container
                class="row-action"
                >
                @for (accountMoveLine of accountMove.accountMoveLines; track trackByAccountMoveLineId($index, accountMoveLine)) {
                  <tr>
                    <td>{{ accountMoveLine.creationDate | date : "dd/MM/yyyy" }}</td>
                    <td>{{ accountMoveLine.paymentModeLoc }}</td>
                    <td>{{ accountMoveLine.unitPrice | currency : "EUR" }}</td>
                    <td>
                      @if (!accountMoveLine.documentId) {
                        <app-generic-file-input
                          [format]="'link'"
                          [isValidationButton]="false"
                          [isClearButton]="false"
                          (fileEmitter)="onValidationEmitterUploadFile($event, accountMoveLine.id, this.contactId)"/>
                        }
                        @if (accountMoveLine.documentId) {
                          <a
                            role="button"
                            (click)="onClickShowDocument(accountMoveLine.documentId)"
                            translate
                          >PAYMENT_LBL_SHOW_DOCUMENT</a>
                          <!--                <ng-container *ngIf="accountMoveLine.paymentMode === 'Cash'">-->
                          <!--                 | <app-generic-file-input [format]="'link'" [isValidationButton]="true" (validationEmitter)="onValidationEmitterUploadFile($event, accountMoveLine.id, contactDetail.id)" />-->
                        <!--                </ng-container>-->
                      }
                    </td>
                    <td>{{ accountMove.statusLoc }}</td>
                    <td>
                      @for (action of accountMove.actions; track action; let last = $last) {
                        <a role='button'
                          (click)="this.triggerAction(action.name, accountMove.id, this.contactId)"
                        translate>{{ action.actionName }}{{ last ? '' : ' | ' }}</a>
                      }
                    </td>
                    <td>
                      @if (accountMove.issuingAccountMoves.length == 0 && accountMove.status != 'Cancel') {
                        <a
                          role='button'
                  (click)="
                      openModalBindAccountMoves(
                        this.contactId,
                        accountMove.id
                      )
                    "
                          translate
                          >PAYMENT_LBL_BIND_ACCOUNT_MOVE_SLIP</a
                          >
                        }
                        @if (accountMove.issuingAccountMoves.length > 0) {
                          <a
                            role='button'
                            (click)="openModalBindAccountMovesDetails(this.contactId ,accountMove, 'Slip')"
                          translate>{{ accountMove.issuingAccountMoves | showJournalAndTruncate: [50] }}</a>
                        }
                      </td>
                    </tr>
                  }
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }
